module.exports = __webpack_public_path__ + "static/media/screenshoteye.c2f18d8b.svg";